
const TripCaption = ({ trip }) => {

    if (trip === null) {
        return <></>;
    }

    let num_people = 0;
    for (let pt in trip.person_trips) {
      num_people += trip.person_trips[pt].person.group_size;
    }
    const num_people_text = (num_people > 1) ?
                            `${num_people} voyagers` :
                            `1 voyager`;

    return (
      <g fill="white"
         textAnchor="middle"
         className="trip_caption"
         style={{fontSize: 30}}>
        <text dy="-0.45em">{trip.trip_key_memory}</text>
        <text dy="1.15em">{trip.trip_date}</text>
        <text dy="2.75em">{num_people_text}</text>
      </g>
    );
  };

  export default TripCaption;
